import { render, staticRenderFns } from "./analisarDocumento.vue?vue&type=template&id=8e706188&scoped=true&"
import script from "./analisarDocumento.vue?vue&type=script&lang=js&"
export * from "./analisarDocumento.vue?vue&type=script&lang=js&"
import style0 from "./analisarDocumento.vue?vue&type=style&index=0&id=8e706188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e706188",
  null
  
)

export default component.exports